import { useEffect } from "react";
import { Link } from "react-router-dom";
import { setPageMeta } from "@/lib/api";
import { Splatter } from "@/components/Splatter";
import { ExternalLink, ShieldAlert, Send, Search } from "lucide-react";

const SITES = [
  { name: "MakerWorld", url: "https://makerworld.com", desc: "Immense bibliothèque de modèles prêts à imprimer." },
  { name: "Printables", url: "https://www.printables.com", desc: "Modèles gratuits de la communauté Prusa." },
  { name: "Thingiverse", url: "https://www.thingiverse.com", desc: "La référence historique des fichiers 3D." },
  { name: "Creality Cloud", url: "https://www.crealitycloud.com", desc: "Modèles et communauté Creality." },
  { name: "Cults3D", url: "https://cults3d.com", desc: "Fichiers gratuits et payants de créateurs indépendants." },
  { name: "Etsy", url: "https://www.etsy.com/fr/search?q=fichier+stl", desc: "Fichiers STL vendus par des designers." },
];

export default function Find3DFile() {
  useEffect(() => { setPageMeta("Trouver un fichier 3D — Tenay Ain-Pression", "Où trouver un fichier 3D (STL, 3MF, OBJ, STEP) : MakerWorld, Printables, Thingiverse, Creality Cloud, Cults3D, Etsy. Envoyez-le nous pour devis."); }, []);
  return (
    <div>
      <section className="relative overflow-hidden border-b border-white/10">
        <Splatter />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-14">
          <h1 className="font-heading text-4xl sm:text-5xl font-black">Trouver un <span className="text-[#0055FF]">fichier 3D</span></h1>
          <p className="mt-4 text-gray-300 max-w-2xl text-lg">
            Vous n'avez pas encore de modèle ? Pas de problème. <strong className="text-white">Inscription gratuite, trouvez un fichier
            puis envoyez-le pour devis.</strong> Des milliers de modèles existent déjà en ligne, gratuits ou payants,
            prêts à être imprimés chez nous.
          </p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <h2 className="flex items-center gap-2 font-heading text-2xl font-bold"><Search className="w-6 h-6 text-[#E6007E]" /> Où chercher</h2>
        <div className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {SITES.map((s, i) => (
            <a key={s.name} href={s.url} target="_blank" rel="noopener noreferrer"
              data-testid={`site-${s.name.toLowerCase().replace(/\s/g, "")}`}
              className="fade-up card-hover group rounded-2xl border border-[#222] bg-[#0A0A0A] p-6" style={{ animationDelay: `${i * 60}ms` }}>
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-xl font-bold group-hover:text-[#E6007E] transition-colors">{s.name}</h3>
                <ExternalLink className="w-5 h-5 text-[#0055FF]" />
              </div>
              <p className="mt-2 text-sm text-gray-400">{s.desc}</p>
            </a>
          ))}
        </div>

        <div className="mt-10 rounded-2xl border border-[#E6007E]/40 bg-[#E6007E]/10 p-6 flex items-start gap-4">
          <ShieldAlert className="w-7 h-7 text-[#E6007E] shrink-0" />
          <p className="text-gray-200">
            <strong>Vérifiez toujours les droits d'utilisation</strong> du fichier avant de nous l'envoyer. Certains modèles sont
            réservés à un usage personnel et ne peuvent pas être imprimés à des fins commerciales. Respecter le travail des créateurs,
            c'est important.
          </p>
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-400 mb-4">Formats acceptés : STL, 3MF, OBJ, STEP</p>
          <Link to="/impression-fichier-3d" data-testid="found-file-btn"
            className="inline-flex items-center gap-2 btn-blue rounded-full px-8 py-4 text-base font-bold">
            <Send className="w-5 h-5" /> J'ai trouvé mon fichier, l'envoyer pour devis
          </Link>
        </div>
      </div>
    </div>
  );
}
